/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from 'styled-components/macro';
import styledFuncs from 'app/styles/styledFuncs';
import {
  DiagnosisQuote,
  QuoteSummery,
  QuoteDetails as RepairQuoteDetails,
  EventEntity,
} from 'app/core/api/repairer/api-repairer.types';
import { useEffect, useState } from 'react';

type Props = {
  quoteSummery?: QuoteSummery;
  quoteEventEntity?: EventEntity;
};
export default function QuoteDetails({
  quoteSummery,
  quoteEventEntity,
}: Props): JSX.Element {
  const [totalAmount, setTotalAmount] = useState<number>(0);
  // useEffect(() => {
  //   const amount = quoteSummery?.diagnosisQuote
  //     ? quoteSummery.diagnosisQuote
  //         .map(item => item.quotationAmount.amount)
  //         .reduce((prev, curr) => prev + curr, 0)
  //     : 0;
  //   const amount1 = quoteSummery?.repairQuote
  //     ? quoteSummery.repairQuote
  //         .map(item => item.quotationAmount.amount)
  //         .reduce((prev, curr) => prev + curr, 0)
  //     : 0;
  //   setTotalAmount(amount1 !== 0 ? amount1 : amount);
  // }, [quoteSummery?.diagnosisQuote, quoteSummery?.repairQuote]);
  useEffect(() => {
    if (quoteEventEntity?.actionData) {
      const amount =
        quoteEventEntity?.actionData?.quotationAmount?.amount;
      setTotalAmount(amount ?? 0);
    }
  }, [
    quoteEventEntity?.actionData,
    quoteEventEntity?.actionData?.quotationAmount?.amount,
  ]);
  const Table = styled.table`
    border-collapse: separate;
    table-layout: fixed;
    th {
      text-align: left;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
    }
    th:first-child {
      width: 50%;
    }
    th:nth-child(2) {
      text-align: center;
      width: 20%;
    }
    th:nth-child(3) {
      text-align: right;
      width: 30%;
    }
    tr {
      border-radius: 10px;
    }
    td {
      border-top: 1px solid #eaeaea;
      border-bottom: 1px solid #eaeaea;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
      color: #000;
    }
    td:first-child {
      border-left: 1px solid #eaeaea;
      width: 50%;
      border-radius: 10px 0 0 10px;
      overflow-wrap: break-word;
    }
    td:nth-child(2) {
      text-align: center;
      width: 20%;
      border-right: solid 1px #fff !important;
    }
    td:last-child {
      border-right: 1px solid #eaeaea;
      border-radius: 0 10px 10px 0;
      text-align: right;
      width: 30%;
    }
    tr:last-child td {
      color: #31ad31;
    }
    thead {
      font-weight: 600;
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    tbody {
      display: table;
      table-layout: fixed;
      width: 100%;
      border-spacing: 0 10px;
    }
  `;

  return (
    <div style={{ display: 'block', margin: '0 auto' }}>
      <Table>
        <thead>
          <tr>
            <th>Description</th>
            <th>Qty</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {!quoteEventEntity?.actionData?.quoteDetails && (
            <>
              {quoteEventEntity?.actionData?.quotationAmount && (
                <tr key="diagnosis">
                  <td>Diagnosis Quote</td>
                  <td />
                  <td>
                    £
                    {
                      quoteEventEntity?.actionData?.quotationAmount
                        .amount
                    }
                  </td>
                </tr>
              )}
            </>
          )}
          {quoteEventEntity?.actionData?.quoteDetails &&
            quoteEventEntity?.actionData.quoteDetails.map(
              (rdq: RepairQuoteDetails, rdqIndex) => (
                // new Date().toString()
                <tr key={`repair${rdqIndex + 1}`}>
                  <td>
                    {rdq.description
                      ? rdq.description
                      : 'Repair Quote'}
                  </td>
                  <td>{rdq.qty}</td>
                  <td>
                    {rdq.qty > 1 && (
                      <span
                        style={{
                          color: '#a8a8a8',
                          float: 'left',
                        }}
                      >
                        (£{rdq.total})
                      </span>
                    )}
                    <span style={{ color: '#000000' }}>
                      £
                      {Number.isInteger(rdq.qty * rdq.total)
                        ? rdq.qty * rdq.total
                        : (rdq.qty * rdq.total).toFixed(2)}
                    </span>
                  </td>
                </tr>
              )
            )}
          <tr>
            <td>Total</td>
            <td />
            <td>£{totalAmount}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
